@import "stylesheets/sdx/typography/typography";
@import "stylesheets/sdx/utilities/screenreaders";

$strike-through: "<svg viewBox='0 0 132 47' fill='none'  xmlns='http://www.w3.org/2000/svg'><path d='M129.229 5.85038C129.248 5.93376 129.255 6.01644 129.261 6.11082C129.284 6.91135 128.626 7.58985 127.803 7.62404C95.6787 8.18087 65.5932 19.7397 36.7995 32.6786C28.2968 36.4013 16.4693 42.1393 8.00652 46.1934C5.7448 47.2248 3.85448 45.5631 3.67616 43.7545C0.573746 42.7507 -0.789199 38.2168 2.65406 36.0438C1.71276 34.6608 1.89306 32.5206 4.04623 31.6826C34.168 21.1013 64.8227 9.51693 96.3878 3.73276C106.987 1.84842 117.923 1.55859 128.575 0.782064C130.02 0.666614 131.295 1.71659 131.414 3.12209C131.525 4.45662 130.559 5.63422 129.229 5.85038Z'";

.period {
  z-index: -1; // make sure the period is behind the strikethrough
}

.text-d1,
.text-d2,
.text-d3,
.text-h1 {
  // for example "/Mt."
  .period {
    font-size: 50%;
    letter-spacing: 0;
  }

  &:not(.integer) {
    .period {
      line-height: 1;
    }
  }

  // display the period above the ndash
  &.integer {
    .period {
      position: absolute;
    }

    &.text-d1,
    &.text-d2 {
      .period {
        font-size: 26%;
        margin-left: -2em;
        margin-top: 0.55em;
      }
    }

    &.text-d3,
    &.text-h1 {
      .period {
        font-size: 12px; // minimum accessible font size
      }
    }

    &.text-d3 {
      .period {
        margin-left: -2em;
        margin-top: 0.5em;
      }
    }

    &.text-h1 {
      .period {
        margin-left: -1.6em;
        margin-top: -0.9em;
      }
    }
  }
}

// save some space
.text-d1,
.text-d2,
.text-d3 {
  line-height: 1;
}

.strikethrough {
  position: relative;
  display: inline-block; // avoid line break after "::before"

  &::before {
    content: "";
    position: absolute;
    top: 5px; // tweaked to match figma design
    left: 0;
    right: 0;
    bottom: 0;
    width: 82%;
    height: 82%;
    margin: auto;
    background-repeat: no-repeat;
    background-position: center center;
  }

  &--pink::before {
    @include background-svg-color($strike-through, $color-pink);
  }

  &--navy::before {
    @include background-svg-color($strike-through, $color-navy);
  }
}
